import { render, staticRenderFns } from "./SeminarEntryMessage.vue?vue&type=template&id=0c5841f2"
import script from "./SeminarEntryMessage.vue?vue&type=script&lang=js"
export * from "./SeminarEntryMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports